import React from 'react';
import { Textarea } from '../ui/textarea';

export const ScaleQuestion = ({ q, value, onChange }) => (
  <div className="surface-card p-4" data-testid={`question-${q.id}`}>
    <p className="text-sm font-medium text-foreground mb-3">{q.text}</p>
    <div className="grid grid-cols-5 gap-1.5">
      {[1, 2, 3, 4, 5].map(n => (
        <button
          key={n}
          onClick={() => onChange(q.id, n)}
          data-testid={`answer-${q.id}-${n}`}
          className={`rounded-xl py-2 text-center transition-colors border ${value === n
            ? 'bg-cyan-600 text-white border-cyan-600 font-bold'
            : 'border-border text-muted-foreground hover:border-cyan-400 hover:text-foreground'}`}
        >
          <span className="text-sm">{n}</span>
          <span className="block text-[9px] leading-tight mt-0.5 px-0.5">{q.scale_labels?.[String(n)]}</span>
        </button>
      ))}
    </div>
  </div>
);

export const SingleQuestion = ({ q, value, onChange }) => (
  <div className="surface-card p-4" data-testid={`question-${q.id}`}>
    <p className="text-sm font-medium text-foreground mb-3">{q.text}</p>
    <div className="flex flex-wrap gap-2">
      {q.options.map(opt => (
        <button
          key={opt}
          onClick={() => onChange(q.id, opt)}
          data-testid={`answer-${q.id}-${opt.replace(/[^a-zA-Z0-9]/g, '-')}`}
          className={`rounded-full px-3.5 py-1.5 text-xs font-medium border transition-colors ${value === opt
            ? 'bg-cyan-600 text-white border-cyan-600'
            : 'border-border text-muted-foreground hover:border-cyan-400 hover:text-foreground'}`}
        >
          {opt}
        </button>
      ))}
    </div>
  </div>
);

export const TextQuestion = ({ q, value, onChange }) => (
  <div className="surface-card p-4" data-testid={`question-${q.id}`}>
    <p className="text-sm font-medium text-foreground mb-2">{q.text} {q.optional && <span className="text-xs text-muted-foreground font-normal">(optional)</span>}</p>
    <Textarea value={value || ''} onChange={(e) => onChange(q.id, e.target.value)} rows={3} className="rounded-xl" data-testid={`answer-text-${q.id}`} />
  </div>
);
